export const version = 'kunde-v1.20.0-SNAPSHOT-ff0f4b34b2f27418c37539129303322561e26877';